import _ from 'lodash';
import { designPanelSettingsChangeSrc38Evid1614 } from '@wix/bi-logger-editor-data/v2';
import { behaviorsUtils, biLogger, stripUtils } from '#packages/util';
import type { designPanelSettingsChangeSrc38Evid1614Params } from '@wix/bi-logger-editor-data/v2/types';
import type { CompRef } from '@wix/document-services-types';
import type { EditorAPI } from '#packages/editorAPI';
import constants from '#packages/constants';

const DESIGN_PANEL_BI_PROPERTY_TO_IGNORE = 'fnt';

const reportOnChangePure = (
  biParams: designPanelSettingsChangeSrc38Evid1614Params,
) => {
  if (biParams.setting_name === DESIGN_PANEL_BI_PROPERTY_TO_IGNORE) {
    return;
  }
  biLogger.report(designPanelSettingsChangeSrc38Evid1614(biParams));
};

export const reportOnChangeDebounced = _.debounce(reportOnChangePure, 500);

/* WEED-33155 | Temporary solution will remove on merge dm_bgScrubToMotionFixer */
export const onShadowEnabledChange = (
  editorAPI: EditorAPI,
  compRef: CompRef,
  newVal: boolean,
) => {
  if (!newVal) {
    return;
  }

  const compType = editorAPI.components.getType(compRef);

  const isDesignedStripOrColumnComp =
    compType === constants.COMP_TYPES.STRIP_COLUMNS_CONTAINER ||
    compType === constants.COMP_TYPES.COLUMN;

  if (!isDesignedStripOrColumnComp) {
    return;
  }

  const hasProblematicScrollEffect =
    stripUtils.isStripOrColumnHasProblematicScrollEffect(editorAPI, compRef);

  if (!hasProblematicScrollEffect) {
    return;
  }

  behaviorsUtils.removeBehaviorsByAction(
    editorAPI,
    compRef,
    'bgScrub',
    'DESKTOP',
  );
};
